module.exports = __webpack_public_path__ + "media/2300-2_YR_2021_WirelessConnection.6b4b0c66.mp4";